import { useAbandonedBookings } from 'components/Bookings2/Abandoned/AbandonedBookingsProvider';
import styles from 'components/Bookings2/Abandoned/Table/AbandonedBookingsTable.module.scss';
import Button from 'components/UI/V2/Button/Button';
import { TableBody } from 'components/UI/V3/Table/Body/TableBody';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { TableEmptyState } from 'components/UI/V3/Table/EmptyState/TableEmptyState';
import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { Table } from 'components/UI/V3/Table/Table';
import { useHasPremiumAccess } from 'hooks';
import { OnlineBookingStepNames } from 'model/OnlineBooking';
import React from 'react';
import { Link } from 'react-router-dom';
import { ClientsPath } from 'routes/Paths';
import { hashForUrl } from 'utils/HashUtils';

export const AbandonedBookingsTable: React.FC = () => {
    const {
        page,
        setPage,
        size,
        setSize,
        totalPages,
        type,
        isLoading,
        bookingAttempts,
        sendSmsHandler,
        openCreateBookingHandler
    } = useAbandonedBookings();

    const hasTwoWaySMSPremiumAccess = useHasPremiumAccess('two_way_sms');

    const generateClientPath = React.useCallback((customerId: number) => {
        const hash = hashForUrl({ clientId: customerId, petId: undefined });

        return `${ClientsPath}/${hash}`;
    }, []);

    return (
        <Table
            paginable
            firstColumnFixed
            pagination={{ page, size, totalPages }}
            onPageChange={setPage}
            onSizeChange={setSize}
        >
            <TableHeader>
                <TableHeaderCell>Name</TableHeaderCell>
                <TableHeaderCell>Type</TableHeaderCell>
                <TableHeaderCell>Pets</TableHeaderCell>
                <TableHeaderCell>Abandoned Step</TableHeaderCell>
                <TableHeaderCell>Abandoned Date</TableHeaderCell>
                <TableHeaderCell />
            </TableHeader>

            <TableBody>
                {bookingAttempts.map(bookingAttempt => (
                    <TableRow key={bookingAttempt.id}>
                        <TableCell>
                            <Link
                                to={generateClientPath(bookingAttempt.customerId)}
                                className={styles.customerLink}
                            >
                                <span className={styles.attemptCustomerName}>{bookingAttempt.name}</span>
                                <span className={styles.attemptCustomerEmail}>{bookingAttempt.email}</span>
                            </Link>
                        </TableCell>
                        <TableCell>{bookingAttempt.type}</TableCell>
                        <TableCell>{bookingAttempt.pets}</TableCell>
                        <TableCell>{OnlineBookingStepNames[bookingAttempt.abandonedStep]}</TableCell>
                        <TableCell>{bookingAttempt.abandonedDate.format('MMM DD, YYYY hh:mm a')}</TableCell>
                        <TableCell isActions>
                            {type !== 'converted' && (
                                <Button
                                    label="Book"
                                    variant="green"
                                    className={styles.actionButton}
                                    isLoading={isLoading.get(bookingAttempt.id) ?? false}
                                    onClick={() => openCreateBookingHandler(bookingAttempt)}
                                />
                            )}
                            {hasTwoWaySMSPremiumAccess && (
                                <Button
                                    label="Send SMS"
                                    variant="black"
                                    className={styles.actionButton}
                                    onClick={() => sendSmsHandler(bookingAttempt)}
                                />
                            )}
                        </TableCell>
                    </TableRow>
                ))}

                {bookingAttempts.length === 0 && <TableEmptyState />}
            </TableBody>
        </Table>
    );
};
